// Two sections load this file, so it can execute twice on one page. The marker
// keeps a single delegated listener — a second would double every add-to-cart.
if (!document.documentElement.dataset.regimenBundleBound) {
  document.documentElement.dataset.regimenBundleBound = 'true';

  // Delegated so a CTA inserted by a section morph works without re-initialising.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-regimen-bundle-cta]');
    if (!button || button.disabled) return;

    const variantIds = JSON.parse(button.dataset.variantIds);
    if (variantIds.length === 0) return;

    const items = variantIds.map((id) => ({ id, quantity: 1 }));
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      button.disabled = true;
      try {
        await CartAPI.addMultiple(items);
      } catch (error) {
        console.error('[RegimenBundle] add failed:', error);
      } finally {
        button.disabled = false;
      }
      return;
    }

    cartDrawer.open();
    // No error handling: the drawer's mutation loop already painted the
    // localised message into its own error slot.
    await cartDrawer.addItems(items, button);
  });
}
